function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e6e6e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23,30a3,3,0,0,0,3-3V22.953a1,1,0,0,0-2,0V27a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H23a1,1,0,0,1,1,1V8.084a1,1,0,0,0,2,0V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5V27a3,3,0,0,0,3,3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M7,19a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M26.606,10.565a1,1,0,0,0-1.414,0l-9.9,9.9a1,1,0,0,0-.293.707V23H7a1,1,0,0,0,0,2H18.829a1,1,0,0,0,.707-.293l9.9-9.9a1,1,0,0,0,0-1.414ZM18.415,23H17V21.586l8.9-8.9L27.314,14.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M15,10.5A4.5,4.5,0,1,0,10.5,15,4.5,4.5,0,0,0,15,10.5ZM10.5,13A2.5,2.5,0,1,1,13,10.5,2.5,2.5,0,0,1,10.5,13Z"
}));

function SvgOrderHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.728,
    height: 28,
    viewBox: "0 0 27.728 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryIcon);
export default __webpack_public_path__ + "static/media/order-history-icon.8747bcef.svg";
export { ForwardRef as ReactComponent };